var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',{staticClass:"barrage"},[_c('vue-danmaku',{attrs:{"useSlot":"","danmus":_vm.items,"loop":"","channels":_vm.line},scopedSlots:_vm._u([{key:"dm",fn:function(ref){
var index = ref.index;
var danmu = ref.danmu;
return [_c('barrage-item',{attrs:{"profile":danmu.member_img,"nickname":danmu.member_nickname,"character":danmu.level,"desc":danmu.title}})]}}],null,false,2880900606)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }